<script>
export default {
  name: 'SliderPlaceholder',
};
</script>

<template>
  <div class="slider-placeholder">
    <div class="slider-placeholder__header">
      <div class="slider-placeholder__header-icon"></div>
      <div class="slider-placeholder__header-field"></div>
    </div>
    <div class="slider-placeholder__main">
      <div class="slider-placeholder__slider-track"></div>
    </div>
  </div>
</template>
